
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: { classComponent: String, imageSource: String },
})
export default class SectionArea extends Vue {}
